import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'
import { useFormikContext } from 'formik'

type Props = {
  fieldName: string
}

export function useHandlers(props: Props) {
  const { fieldName } = props

  const { setFieldValue } = useFormikContext<ILeadFormModel>()

  function handleAccept(date: Date | null): void {
    setFieldValue(fieldName, date)
  }

  return { handleAccept }
}
